{
	"title": "NOCs",
	"subtitle": "The organizations with athletes approved in GMS or entries in {{games}}. Click a row to open the NOC.",
	"detailTitle": "NOC",
	"medal": {
		"gold": "Gold",
		"silver": "Silver",
		"bronze": "Bronze"
	},
	"medalCounts": "{{gold}} gold, {{silver}} silver, {{bronze}} bronze",
	"table": {
		"noc": "NOC",
		"name": "Name",
		"athletes": "Athletes",
		"entries": "Entries",
		"open": "Open {{name}}",
		"count_one": "{{n}} NOC",
		"count_other": "{{n}} NOCs"
	},
	"empty": {
		"noneTitle": "No NOCs have athletes in {{games}} yet",
		"noneBody": "An NOC appears here once GMS approves one of its athletes, or once it has an entry in an event.",
		"noGamesTitle": "No games are set up yet",
		"noGamesBody": "Games are created in GMS. Ask your administrator."
	},
	"errors": {
		"gamesTitle": "The games could not load"
	},
	"detail": {
		"loading": "Loading the NOC…",
		"notFoundTitle": "This NOC could not be found",
		"notFoundBody": "Pick an NOC from the list.",
		"backToList": "All NOCs",
		"noAthletesTitle": "{{noc}} has no athletes in {{games}}",
		"noEntriesTitle": "{{noc}} has no entries in {{games}}",
		"noEntriesBody": "Switch games in the sidebar to see its other games.",
		"facts": {
			"athletes": "Athletes",
			"entries": "Entries",
			"sports": "Sports"
		},
		"athletesLink": "Athletes of this NOC",
		"tabs": {
			"label": "Sections",
			"sports": "By sport",
			"entries": "Entries",
			"medals": "Medals"
		},
		"sports": {
			"title": "By sport",
			"description": "Click a sport to see this NOC's entries in it.",
			"sport": "Sport",
			"entries": "Entries",
			"athletes": "Athletes",
			"medals": "Medals",
			"open": "Open the {{sport}} entries"
		},
		"entries": {
			"title": "Entries",
			"description": "In programme order. Click a row to open the entry and its roster."
		},
		"medals": {
			"title": "Medals",
			"description": "Awarded by the medal desk, newest first.",
			"medal": "Medal",
			"event": "Event",
			"entry": "Entry",
			"awarded": "Awarded",
			"none": "No medals awarded yet.",
			"more": "Next {{n}}",
			"allLoaded": "That is every medal.",
			"showing_one": "Showing {{n}} medal",
			"showing_other": "Showing {{n}} medals",
			"open": "Open the entry"
		}
	}
}
